<template>
  <header class="da-hero">
    <div class="da-hero__inner">
      <div class="da-hero__left">
        <div class="da-hero__icon-wrap">
          <feather-icon
            icon="BarChart2Icon"
            size="28"
            class="da-hero__icon"
          />
        </div>
        <div class="da-hero__copy">
          <h1 class="da-hero__title">
            Desempenho de Atendentes
          </h1>
          <p class="da-hero__subtitle">
            Acompanhe o ranking de atendentes e veja métricas resumidas de desempenho no período selecionado.
          </p>
          <router-link
            :to="{ name: 'dashboard-main' }"
            class="da-hero__home"
            title="Ir para o início"
          >
            <feather-icon
              icon="HomeIcon"
              size="16"
            />
            <span>Início</span>
          </router-link>
        </div>
      </div>
      <div class="da-hero__badge-wrap">
        <div
          class="da-hero__badge"
          :title="periodRange || periodLabel"
        >
          <span
            v-if="periodRange"
            class="da-hero__badge-dot"
            aria-hidden="true"
          />
          <span class="da-hero__badge-text">{{ periodLabel }}</span>
        </div>
        <p
          v-if="periodRange"
          class="da-hero__badge-range"
        >
          {{ periodRange }}
        </p>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeroDesempenhoAtendentes',
  props: {
    periodLabel: {
      type: String,
      default: '',
    },
    periodRange: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.da-hero {
  --mc-gradient-main: linear-gradient(135deg, #6f35d0 0%, #b13ccf 45%, #ff6f61 100%);
  --mc-shadow-lg: 0 18px 45px rgba(120, 70, 180, 0.18);
  border-radius: 28px;
  background: var(--mc-gradient-main);
  box-shadow: var(--mc-shadow-lg);
  padding: 36px 40px;
  margin-bottom: 28px;
  font-family: 'Plus Jakarta Sans', 'Sora', system-ui, sans-serif;
}

.da-hero__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
}

.da-hero__left {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  flex: 1;
  min-width: 0;
}

.da-hero__icon-wrap {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}

.da-hero__icon {
  color: #fff !important;
}

.da-hero__title {
  margin: 0 0 0.5rem;
  font-size: clamp(1.65rem, 4vw, 2.35rem);
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.03em;
  line-height: 1.15;
}

.da-hero__subtitle {
  margin: 0 0 0.75rem;
  font-size: clamp(0.95rem, 2vw, 1.15rem);
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.5;
  max-width: 520px;
}

.da-hero__home {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: rgba(255, 255, 255, 0.95) !important;
  font-size: 0.88rem;
  font-weight: 600;
  text-decoration: none;
  opacity: 0.95;
  transition: opacity 0.2s ease;
}

.da-hero__home:hover {
  opacity: 1;
  color: #fff !important;
}

.da-hero__badge-wrap {
  flex-shrink: 0;
  text-align: right;
}

.da-hero__badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1.15rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(8px);
}

.da-hero__badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
}

.da-hero__badge-text {
  font-size: 0.9rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}

.da-hero__badge-range {
  margin: 0.65rem 0 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  max-width: 220px;
  margin-left: auto;
  line-height: 1.35;
}

@media (max-width: 767px) {
  .da-hero {
    padding: 28px 22px;
  }

  .da-hero__badge-wrap {
    text-align: left;
    width: 100%;
  }

  .da-hero__badge-range {
    margin-left: 0;
  }
}
</style>
